export default __webpack_public_path__ + "static/media/1.4faebda7.jpg";